import { legacy_createStore, combineReducers, applyMiddleware } from "redux";

import storage from 'redux-persist/lib/storage'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import { profileReducer } from "./profileReducer";
const reducers = combineReducers({
  profile:profileReducer !== undefined && profileReducer
});

const persistConfig = {
key: 'root',
storage
};

const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })
export default store;

export type RootState = ReturnType<typeof store.getState>;
